import {provideHttpClient, withInterceptorsFromDi, withXhr} from '@angular/common/http';
import {isDevMode, NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ServiceWorkerModule} from '@angular/service-worker';
import {L10nIntlModule, L10nTranslationModule} from 'angular-l10n';
import {CookieModule} from 'ngx-cookie';
import {AppEnvSpecificModule} from './app-env-specific.module';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {getUrlRelativeToPublicPath} from './common/public-path';
import {AppHeaderModule} from './components/app-header/app-header.module';
import {AppUpdatesComponent} from './components/application-reload/app-updates/app-updates.component';
import {ApplicationReloadModule} from './components/application-reload/application-reload.module';
import {AuthModule} from './components/auth';
import {DropdownMenuModule} from './components/dropdown-menu';
import {DynamicComponentFactoryModule} from './components/dynamic-component';
import {DynamicXyzDaemonComponent} from './components/dynamic-xyz/dynamic-xyz-daemon.component';
import {DynamicZyxGlobalDaemonModule} from './components/dynamic-xyz/dynamic-zyx-global-daemon.module';
import {FlashMessageModule} from './components/flash-message';
import {InvPortfolioModule} from './components/investment-portfolio';
import {LanguageSelectorModule} from './components/language-selector';
import {LoadingIndicatorModule} from './components/loading-indicator';
import {LogExceptionsService} from './components/logger/log-exceptions.service';
import {LoggerModule} from './components/logger/logger.module';
import {ModalModule} from './components/modal';
import {ResizeObserverService} from './components/resize-observer';
import {SvgSpriteModule} from './components/svg-sprite';
import {SystemStatusIndicatorModule} from './components/system-status-indicator';
import {l10nConfig, L10nModule} from './components/translate';
import {L10nStorageService} from './components/translate/l10n-storage.service';
import {TranslationFallback} from './components/translate/translation-fallback';
import {UserDataResolverService} from './pages/dashboard/user-data-resolver.service';
import {NoContentPageModule} from './pages/no-content-page';
import {AppConfigService} from './services/config.service';
import {ContextMenuService} from './services/context-menu-service';
import {EchoService} from './services/echo.service';
import {HtmlSymbolService} from './services/html-symbol.service';
import {KeyboardShortcutService} from './services/keyboard-shortcut.service';
import {LocalStorageService} from './services/local-storage.service';
import {RouteChangesService} from './services/route-changes.service';
import {SettingsApiService} from './services/settings-api.service';
import {SignUpService} from './services/sign-up.service';
import {UserService} from './services/user.service';
import {WindowRefService} from './services/window-ref.service';

console.warn('app.module cl-ui, bo-ui', {
    'ngsw-path': getUrlRelativeToPublicPath('sw-master.js')
}); // TODO

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({ bootstrap: [AppComponent],
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        // TODO: ServiceWorker, see also "serviceWorker" flag in angular.json
        ServiceWorkerModule.register(getUrlRelativeToPublicPath('sw-master.js'), {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000',
            scope:                getUrlRelativeToPublicPath('/')
        }),
        BrowserAnimationsModule,
        AuthModule,
        FormsModule,
        AppHeaderModule,
        AppEnvSpecificModule,
        AppRoutingModule,
        NoContentPageModule,
        LoadingIndicatorModule,
        DropdownMenuModule,
        FlashMessageModule,
        ModalModule,
        L10nTranslationModule.forRoot(l10nConfig, {
            translationFallback: TranslationFallback,
            storage:             L10nStorageService
        }),
        L10nIntlModule,
        L10nModule,
        LanguageSelectorModule,
        ApplicationReloadModule,
        // AccountsModule, // [HED-930] There are no accounts in DEX
        DynamicComponentFactoryModule,
        InvPortfolioModule,
        SystemStatusIndicatorModule,
        SvgSpriteModule,
        CookieModule.withOptions(),
        LoggerModule,
        DynamicXyzDaemonComponent,
        DynamicZyxGlobalDaemonModule,
        AppUpdatesComponent
    ],
    providers: [
        LocalStorageService,
        AppConfigService,
        RouteChangesService,
        HtmlSymbolService,
        WindowRefService,
        ContextMenuService,
        KeyboardShortcutService,
        UserService,
        UserDataResolverService,
        SignUpService,
        SettingsApiService,
        ResizeObserverService,
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        EchoService, // [DEX] Echo is used to notify about auth in Dynamic
        LogExceptionsService
    ]
})
export class AppModule {

    constructor(
        private logExceptionsService: LogExceptionsService
    ) {
        this.logExceptionsService.init();
    }

}
